import React, { Component } from 'react';
import VideoPlayback from '../../../VideoPlayback/VideoPlayback';
import loadFonts from '../../../utils/fontLoader';
const Hostnames = {
  INTERNAL: process.env.REACT_APP_INTERNAL_HOSTNAME,
};
class VideoRecorder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewEnabled: false,
      sceneTexts: [],
    };
    this.videoPlayBack = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sceneTexts !== this.state.sceneTexts) {
      let timer = setInterval(() => {
        if (document.fonts.status === 'loaded') {
          this.setState({
            previewEnabled: true,
          });
          clearInterval(timer);
        }
      }, 2000);
    }
  }

  playPreview = () => {
    if (this.videoPlayBack.current) {
      this.videoPlayBack.current.Play();
    }
  };

  getFontfamily = (fontName, decoration) => {
    if (fontName.includes('.ttf')) {
      fontName = fontName.replace('.ttf', '');
    }
    let result = {};
    if (fontName === 'Arial-Bold') {
      result.fontFamily = 'Arial';
      result.fontWeight = 'bold';
    } else if (fontName === 'Arial') {
      result.fontFamily = 'Arial';
    } else if (fontName === 'Calibri-Bold') {
      result.fontFamily = 'Calibri';
      result.fontWeight = 'bold';
    } else if (fontName === 'Calibri') {
      result.fontFamily = 'Calibri';
    } else if (fontName === 'Helvetica') {
      result.fontFamily = 'Helvetica';
      result.fontWeight = 'normal';
    } else if (fontName === 'Helvetica-Regular') {
      result.fontFamily = 'Helvetica';
      result.fontWeight = 'normal';
    } else if (fontName === 'HelveticaNeue-Medium') {
      result.fontFamily = 'Helvetica Neue';
      result.fontWeight = 'bold';
    } else if (fontName === 'Lato-Bold') {
      result.fontFamily = 'Lato';
      result.fontWeight = 'bold';
    } else if (fontName === 'Lato-Black') {
      result.fontFamily = 'Lato';
      result.fontWeight = '900';
    } else if (fontName === 'Merriweather-Bold') {
      result.fontFamily = 'Merriweather';
      result.fontWeight = 'bold';
    } else if (fontName === 'Montserrat-Bold') {
      result.fontFamily = 'Montserrat';
      result.fontWeight = 'bold';
    } else if (fontName === 'Montserrat-ExtraBold') {
      result.fontFamily = 'Montserrat';
      result.fontWeight = '900';
    } else if (fontName === 'NotoSans') {
      result.fontFamily = 'Noto Sans';
    } else if (fontName === 'NotoSans-Bold') {
      result.fontFamily = 'Noto Sans';
      result.fontWeight = 'bold';
    } else if (fontName === 'NotoSansJP') {
      result.fontFamily = 'Noto Sans JP';
    } else if (fontName === 'NotoSansJP-Bold') {
      result.fontFamily = 'Noto Sans JP';
      result.fontWeight = 'bold';
    } else if (fontName === 'NotoSerifJP') {
      result.fontFamily = 'Noto Serif JP';
    } else if (fontName === 'NotoSerifJP-Bold') {
      result.fontFamily = 'Noto Serif JP';
      result.fontWeight = 'bold';
    } else if (fontName === 'OpenSans') {
      result.fontFamily = 'Open Sans';
    } else if (fontName === 'OpenSans-Bold') {
      result.fontFamily = 'Open Sans';
      result.fontWeight = 'bold';
    } else if (fontName === 'Poppins-Bold') {
      result.fontFamily = 'Poppins';
      result.fontWeight = 'bold';
    } else if (fontName === 'Poppins-ExtraBold') {
      result.fontFamily = 'Poppins';
      result.fontWeight = '900';
    } else if (fontName === 'Quicksand') {
      result.fontFamily = 'Quicksand';
    } else if (fontName === 'Quicksand-Bold') {
      result.fontFamily = 'Quicksand';
      result.fontWeight = 'bold';
    } else if (fontName === 'Roboto') {
      result.fontFamily = 'Roboto';
    } else if (fontName === 'Roboto-Bold') {
      result.fontFamily = 'Roboto';
      result.fontWeight = 'bold';
    } else if (fontName === 'Rokkitt') {
      result.fontFamily = 'Rokkitt';
    } else if (fontName === 'Rokkitt-Bold') {
      result.fontFamily = 'Rokkitt';
      result.fontWeight = 'bold';
    } else if (fontName === 'SourceSansPro') {
      result.fontFamily = 'Source Sans Pro';
    } else if (fontName === 'SourceSansPro-Bold') {
      result.fontFamily = 'Source Sans Pro';
      result.fontWeight = 'bold';
    } else if (fontName === 'Ubuntu') {
      result.fontFamily = 'Ubuntu';
    } else if (fontName === 'Ubuntu-Bold') {
      result.fontFamily = 'Ubuntu';
      result.fontWeight = 'bold';
    } else if (fontName === 'ProximaNova') {
      result.fontFamily = 'ProximaNova';
      result.fontWeight = 'normal';
    } else if (fontName === 'Moondance') {
      result.fontFamily = 'Moon dance';
      result.fontWeight = 'normal';
    } else if (fontName === 'AveriaLibre') {
      result.fontFamily = 'Averia Libre';
      result.fontWeight = 'normal';
    } else if (fontName === 'CourierPrime') {
      result.fontFamily = 'Courier Prime';
      result.fontWeight = 'normal';
    } else if (fontName === 'Grandstander') {
      result.fontFamily = 'Grandstander';
      result.fontWeight = 'normal';
    } else if (fontName === 'JosefinSans') {
      result.fontFamily = 'Josefin Sans';
      result.fontWeight = 'normal';
    } else if (fontName === 'Spacemono') {
      result.fontFamily = 'Space mono';
      result.fontWeight = 'normal';
    } else if (fontName === 'Rowdies') {
      result.fontFamily = 'Rowdies';
      result.fontWeight = 'normal';
    } else if (fontName === 'DancingScript') {
      result.fontFamily = 'Dancing Script';
      result.fontWeight = 'normal';
    } else if (fontName === 'Caveat') {
      result.fontFamily = 'Caveat';
      result.fontWeight = 'normal';
    } else if (fontName === 'Lato') {
      result.fontFamily = 'Lato';
      result.fontWeight = 'normal';
    } else if (fontName === 'Merriweather') {
      result.fontFamily = 'Merriweather';
      result.fontWeight = 'normal';
    } else if (fontName === 'Poppins') {
      result.fontFamily = 'Poppins';
      result.fontWeight = 'normal';
    } else if (fontName === 'Chewy') {
      result.fontFamily = 'Chewy';
      result.fontWeight = 'normal';
    } else if (fontName === 'Anton') {
      result.fontFamily = 'Anton';
      result.fontWeight = 'normal';
    } else if (fontName === 'Barlow') {
      result.fontFamily = 'Barlow';
      result.fontWeight = 'normal';
    } else if (fontName === 'BarlowBlack' || fontName === 'Barlow Black') {
      result.fontFamily = 'Barlow';
      result.fontWeight = '900';
    } else if (fontName === 'BebasNeue') {
      result.fontFamily = 'Bebas Neue';
      result.fontWeight = 'normal';
    } else if (fontName === 'Caprasimo') {
      result.fontFamily = 'Caprasimo';
      result.fontWeight = 'normal';
    } else if (fontName === 'Capriola') {
      result.fontFamily = 'Capriola';
      result.fontWeight = 'normal';
    } else if (fontName === 'CarterOne') {
      result.fontFamily = 'Carter One';
      result.fontWeight = 'normal';
    } else if (fontName === 'ChakraPetch') {
      result.fontFamily = 'Chakra Petch';
      result.fontWeight = 'normal';
    } else if (fontName === 'Chewy') {
      result.fontFamily = 'Chewy';
      result.fontWeight = 'normal';
    } else if (fontName === 'Comfortaa') {
      result.fontFamily = 'Comfortaa';
      result.fontWeight = 'normal';
    } else if (fontName === 'Dangrek') {
      result.fontFamily = 'Dangrek';
      result.fontWeight = 'normal';
    } else if (fontName === 'DeliusUnicase') {
      result.fontFamily = 'Delius Unicase';
    } else if (fontName === 'Gruppo') {
      result.fontFamily = 'Gruppo';
    } else if (fontName === 'JuliusSansOne' || fontName === 'Julius Sans One' || fontName === 'JuliusSans One') {
      result.fontFamily = 'Julius Sans One';
      result.fontWeight = 'normal';
    } else if (fontName === 'PatuaOne') {
      result.fontFamily = 'Patua One';
      result.fontWeight = 'normal';
    } else if (fontName === 'Raleway') {
      result.fontFamily = 'Raleway';
      result.fontWeight = 'normal';
    } else if (fontName === 'Raleway Black' || fontName === 'RalewayBlack') {
      result.fontFamily = 'Raleway';
      result.fontWeight = '900';
    } else if (fontName === 'Raleway Thin' || fontName === 'RalewayThin') {
      result.fontFamily = 'Raleway';
      result.fontWeight = '100';
    } else if (fontName === 'RussoOne') {
      result.fontFamily = 'Russo One';
      result.fontWeight = 'normal';
    } else if (fontName === 'Satisfy') {
      result.fontFamily = 'Satisfy';
      result.fontWeight = 'normal';
    } else if (fontName === 'SpecialElite') {
      result.fontFamily = 'Special Elite';
      result.fontWeight = 'normal';
    } else if (fontName === 'TitilliumWeb') {
      result.fontFamily = 'Titillium Web';
      result.fontWeight = 'normal';
    } else if (fontName === 'TitilliumWebBlack' || fontName === 'TitilliumWeb Black') {
      result.fontFamily = 'Titillium Web';
      result.fontWeight = '900';
    } else if (fontName === 'Unbounded') {
      result.fontFamily = 'Unbounded';
      result.fontWeight = 'normal';
    } else if (fontName === 'JMModern') {
      result.fontFamily = 'JM Modern';
    } else if (fontName === 'Heartbeat') {
      result.fontFamily = 'Heartbeat';
    } else if (fontName === 'Laisha') {
      result.fontFamily = 'Laisha';
    } else if (fontName === 'Strive') {
      result.fontFamily = 'Strive';
    } else if (fontName === 'PartyConfetti') {
      result.fontFamily = 'Party Confetti';
    } else if (fontName === 'ArchivoNarrow') {
      result.fontFamily = 'Archivo Narrow';
      if (decoration?.includes('decor-bold') && decoration?.includes('decor-italics')) {
        result.fontFamily = result.fontFamily + '__BoldItalic';
      } else if (decoration?.includes('decor-bold')) {
        result.fontFamily = result.fontFamily + '__Bold';
      } else if (decoration?.includes('decor-italics')) {
        result.fontFamily = result.fontFamily + '__Italic';
      }
    } else if (fontName === 'DMSans') {
      result.fontFamily = 'DM Sans';
      if (decoration?.includes('decor-bold') && decoration?.includes('decor-italics')) {
        result.fontFamily = result.fontFamily + '__BoldItalic';
      } else if (decoration?.includes('decor-bold')) {
        result.fontFamily = result.fontFamily + '__Bold';
      } else if (decoration?.includes('decor-italics')) {
        result.fontFamily = result.fontFamily + '__Italic';
      }
    } else if (fontName === 'WorkSans') {
      result.fontFamily = 'Work Sans';
      if (decoration?.includes('decor-bold') && decoration?.includes('decor-italics')) {
        result.fontFamily = result.fontFamily + '__BoldItalic';
      } else if (decoration?.includes('decor-bold')) {
        result.fontFamily = result.fontFamily + '__Bold';
      } else if (decoration?.includes('decor-italics')) {
        result.fontFamily = result.fontFamily + '__Italic';
      }
    } else if (fontName === 'LTWave') {
      result.fontFamily = 'LT Wave';
      if (decoration?.includes('decor-bold') && decoration?.includes('decor-italics')) {
        result.fontFamily = result.fontFamily + '__BoldItalic';
      } else if (decoration?.includes('decor-bold')) {
        result.fontFamily = result.fontFamily + '__Bold';
      } else if (decoration?.includes('decor-italics')) {
        result.fontFamily = result.fontFamily + '__Italic';
      }
    } else if (fontName === 'PlusJakarta Sans') {
      result.fontFamily = 'Plus Jakarta Sans';
      if (decoration?.includes('decor-bold') && decoration?.includes('decor-italics')) {
        result.fontFamily = result.fontFamily + '__BoldItalic';
      } else if (decoration?.includes('decor-bold')) {
        result.fontFamily = result.fontFamily + '__Bold';
      } else if (decoration?.includes('decor-italics')) {
        result.fontFamily = result.fontFamily + '__Italic';
      }
    } else if (fontName === 'PlayfairDisplay') {
      result.fontFamily = 'PlayfairDisplay';
      if (decoration?.includes('decor-bold') && decoration?.includes('decor-italics')) {
        result.fontFamily = result.fontFamily + '__BoldItalic';
      } else if (decoration?.includes('decor-bold')) {
        result.fontFamily = result.fontFamily + '__Bold';
      } else if (decoration?.includes('decor-italics')) {
        result.fontFamily = result.fontFamily + '__Italic';
      }
    } else if (fontName === 'Lexend') {
      result.fontFamily = 'Lexend';
      if (decoration?.includes('decor-bold')) {
        result.fontFamily = result.fontFamily + '__Bold';
      }
    } else if (fontName === 'Manrope') {
      result.fontFamily = 'Manrope';
      if (decoration?.includes('decor-bold')) {
        result.fontFamily = result.fontFamily + '__Bold';
      }
    } else if (fontName === 'Mustard') {
      result.fontFamily = 'Mustard';
      if (decoration?.includes('decor-bold')) {
        result.fontFamily = result.fontFamily + '__Bold';
      }
    } else if (fontName === 'Sora') {
      result.fontFamily = 'Sora';
      if (decoration?.includes('decor-bold')) {
        result.fontFamily = result.fontFamily + '__Bold';
      }
    } else if (fontName === 'Optik') {
      result.fontFamily = 'Optik';
      if (decoration?.includes('decor-bold')) {
        result.fontFamily = result.fontFamily + '__Bold';
      }
    } else if (fontName === 'SpaceGrotesk') {
      result.fontFamily = 'Space Grotesk';
      if (decoration?.includes('decor-bold')) {
        result.fontFamily = result.fontFamily + '__Bold';
      }
    } else {
      result.fontFamily = fontName;
    }
    return result;
  };

  loadFonts = async () => {
    let subScenes = [];
    try {
      await this.loadCustomFonts();
      if (this.props.recordingData && this.props.recordingData.scenes && this.props.recordingData.scenes.length > 0) {
        let counter = 1;
        for (let scene of this.props.recordingData.scenes) {
          if (scene.sub_scenes && scene.sub_scenes.length > 0) {
            for (let sub_scene of scene.sub_scenes) {
              counter = this.addTextElementsToLoadFonts(sub_scene, subScenes, counter);
              if (sub_scene.displayItems && sub_scene.displayItems.length > 0) {
                for (let dispItem of sub_scene.displayItems) {
                  counter = this.addTextElementsToLoadFonts(dispItem, subScenes, counter);
                }
              }
            }
          }
        }
      }
    } catch {}
    this.setState({
      sceneTexts: subScenes,
    });
  };

  addTextElementsToLoadFonts(sub_scene, subScenes, counter) {
    let sceneText = '';
    if (sub_scene.text_lines && sub_scene.text_lines.length > 0) {
      for (let text_line of sub_scene.text_lines) {
        if (text_line && text_line.text) {
          sceneText = `${sceneText} ${text_line.text}`;
        }
      }
    }
    if (!sceneText) {
      sceneText = 'abcd';
    }
    if (sub_scene.font && sub_scene.font.name) {
      let fontResult = this.getFontfamily(sub_scene.font.name, sub_scene.font.decoration);

      if (sub_scene.font.decoration && (sub_scene.font.decoration == 'decor-bold' || sub_scene.font.decoration.includes('decor-bold'))) {
        fontResult.fontWeight = 'bold';
      }
      subScenes.push(
        <span key={counter} style={{ fontFamily: fontResult.fontFamily, fontWeight: fontResult.fontWeight }}>
          {sceneText}
        </span>
      );
    } else {
      subScenes.push(<span key={counter}>{sceneText}</span>);
    }
    counter++;
    return counter;
  }

  loadCustomFonts = async () => {
    try {
      const { recordingData } = this.props;
      if (!recordingData?.scenes?.length) {
        return;
      }

      const fontsToLoad = [];
      for (let scene of recordingData.scenes) {
        // Check scene main fonts
        if (scene.sub_scenes && scene.sub_scenes.length > 0) {
          for (let subScene of scene.sub_scenes) {
            if (subScene.font) {
              const { fontUrl, name } = subScene.font;
              if (fontUrl && name) {
                const fontName = name.replace('.ttf', '');
                fontsToLoad.push({ name: fontName, url: this.getUrl(fontUrl) });
              }
              // Check displayItems fonts
              const displayItems = subScene.displayItems || [];
              if (Array.isArray(displayItems) && displayItems.length > 0) {
                for (let displayItem of displayItems) {
                  if (displayItem.font) {
                    const { fontUrl: displayFontUrl, name: displayName } = displayItem.font;
                    if (displayFontUrl && displayName) {
                      const displayFontName = displayName.replace('.ttf', '');
                      fontsToLoad.push({
                        name: displayFontName,
                        url: this.getUrl(displayFontUrl),
                      });
                    }
                  }
                }
              }
            }
          }
        }
      }

      if (fontsToLoad.length > 0) {
        await loadFonts(fontsToLoad);
      }
    } catch (error) {}
  };

  getUrl = (url) => {
    const hostname = new URL(url).hostname;
    return hostname === Hostnames.INTERNAL ? `${url}?${this.props.recordingData?.userStorageToken}` : url;
  };

  render() {
    return (
      <div>
        <div>{this.state.sceneTexts}</div>
        <button id="loadFontsBtn" onClick={this.loadFonts}>
          Load Fonts
        </button>
        {this.state.previewEnabled ? (
          <button id="playPreviewButton" onClick={this.playPreview}>
            Play preview
          </button>
        ) : (
          <></>
        )}
        <VideoPlayback
          ref={this.videoPlayBack}
          forceCanvas={true}
          width={this.props.width}
          height={this.props.height}
          webmrecording={this.props.webmrecording}
          framesdestination={this.props.framesdestination}
          videoJson={this.props.recordingData}
          recordVideo={true}
        />
      </div>
    );
  }
}

export default VideoRecorder;
